import React, { Component, Fragment } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { DataPropertyRow } from "../../../../libraries/ReportGenerator/DataPropertyRow";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInlineInfoSection, { ReportTitleInfoInlineWhiteSpace } from "../../../../libraries/ReportGenerator/ReportInlineInfoSection";
import { ONR_InServiceRailFailureReportInstructions } from "./instructions";
import ReportSignatureFooter from "../../../../libraries/ReportGenerator/ReportSignatureFooter";
import { onrInServiceRailFailureReportDefects, onrInServiceRailFailureReportinstrucions } from "./instructionsList";
import { TickBox } from "../../../../libraries/ReportGenerator/TickBox";
import { EqualContentsRow } from "../../../../libraries/ReportGenerator/EqualContentsRow";
import { GPS_DECIMAL_PLACES } from "../../../../config/constants";
import { limitDecimalPlacesIfExceed } from "../../../../utils/numberUtils";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";

const contentFontSize = "20px";
const yesNoOptions = ["YES", "", "NO", "", ""];
const typeOfJointOptions = ["STANDARD", "", "COMPROMISE", "", "INSULATED"];
const ifCurveOptions = ["HIGH RAIL", "", "LOW RAIL", "", ""];

const SectionHeader = ({ title }) => {
  return <div style={{ padding: "5px", textAlign: "left", fontSize: contentFontSize, fontWeight: 600 }}>{title}</div>;
};

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, subdivision, user, date, formSummary, isMaintenance } = reportData;
  let { signatureImage } = props;
  if (!formSummary) formSummary = {};

  let data = {
    lineName: subdivision,
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  let reportTitle = reportData.isMaintenance ? "MR Number" : "Title";
  let formValue = reportData.isMaintenance
    ? reportData.formSummary && reportData.formSummary.formId
      ? reportData.formSummary.formId
      : null
    : "N/A";

  return (
    <Fragment>
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection
          title="IN SERVICE RAIL FAILURE AND MORB REPORT"
          {...props}
          centerTitle={true}
          fontSizeOverride="26px"
          isMaintenance={isMaintenance}
        />
        <span className="half-spacer"></span>

        <span className="spacer"></span>
        <ReportInlineInfoSection
          fontSizeOverride={contentFontSize}
          rows={[
            {
              cols: [
                {
                  title: reportTitle,
                  value: reportData.title,
                },

                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "Form ID",
                value: formValue,
                },
              ],
            },
            {
              cols: [
                {
                  title: "DATE",
                  value: data.reportDate,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "SUBDIVISION",
                  value: data.lineName,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "MAIN/SGD/YARD",
                  value: data.myard,
                },
              ],
            },
            {
              cols: [
                {
                  title: "MILEAGE",
                  value: data.mile,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "GPS LOCATION",
                  titleOnly: true,
                },
                {
                  title: "LAT",
                  value: limitDecimalPlacesIfExceed(data.id_lat, GPS_DECIMAL_PLACES),
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "LONG",
                  value: limitDecimalPlacesIfExceed(data.id_long, GPS_DECIMAL_PLACES),
                },
              ],
            },
            {
              cols: [
                {
                  title: "WEIGHT",
                  value: data.weig,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "SECTION",
                  value: data.sect,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "MANUFACTURER",
                  value: data.manuf,
                },
              ],
            },
            {
              cols: [
                {
                  title: "YEAR ROLLED",
                  value: data.yroll,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "MONTH ROLLED",
                  value: data.mroll,
                },
              ],
            },
            {
              cols: [
                {
                  title: "HEAT NUMBER",
                  value: data.hnum,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "INGOT NUMBER",
                  value: data.inum,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "RAIL LETTER",
                  value: data.rlett,
                },
              ],
            },
            {
              cols: [
                {
                  title: "SPECIAL PROCESS DESIGNATION (see instructions)",
                  value: data.spd,
                },
              ],
            },
            {
              cols: [
                {
                  title: "DEFECT (see below)",
                  value: data.defe,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "SIZE",
                  value: data.size,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "LENGTH",
                  value: data.lgth,
                },
              ],
            },
            {
              cols: [
                {
                  title: <TickBox flag={data.morb} label={"IF MOVEMENT OVER RAIL BREAK:-"} />,
                  titleOnly: true,
                },
                {
                  title: "GAP",
                  value: data.gap,
                },
                ReportTitleInfoInlineWhiteSpace,
                {
                  title: "OFFSET",
                  value: data.ofset,
                },
              ],
              className: "red-color",
            },
          ]}
        />
        <EqualContentsRow fontSizeOverride={contentFontSize}>
          <TickBox flag={data.rtype === "JOINTED RAIL"} label={"JOINTED RAIL"} />
          <div></div>
          <TickBox flag={data.rtype === "CWR"} label={"CWR"} />
          <div></div>
          <TickBox flag={data.dir === "EAST RAIL"} label={"EAST RAIL"} />
          <div></div>
          <TickBox flag={data.dir === "WEST RAIL"} label={"WEST RAIL"} />
        </EqualContentsRow>
        <span className="half-spacer"></span>
        <DataPropertyRow title={"DEFECT IN JOINT?"} id={"djoin"} data={data} options={yesNoOptions} fontSizeOverride={contentFontSize} />
        <span className="half-spacer"></span>
        <DataPropertyRow title={"TYPE OF JOINT"} id={"tjoin"} data={data} options={typeOfJointOptions} fontSizeOverride={contentFontSize} />
        <span className="half-spacer"></span>
        <DataPropertyRow title={"IF CURVE:"} id={"curve"} data={data} options={ifCurveOptions} fontSizeOverride={contentFontSize} />
        <span className="half-spacer"></span>
        <SectionHeader title={"REMARKS"} />
        <div>
          <div style={{ border: "2px solid", padding: "5px", fontSize: contentFontSize, height: "150px" }}>{data.com}</div>
        </div>
        <span className="spacer"></span>
        <table className="table-bordered" style={{ width: "100%", fontSize: contentFontSize }}>
          <ReportTableSectionRenderer
            rowsData={onrInServiceRailFailureReportDefects.data}
            section={onrInServiceRailFailureReportDefects.schema}
          />
          <tbody>
            <tr>
              <td colSpan={2}>
                <div style={{ float: "left", display: "inline-block", padding: "10px", height: "64px", lineHeight: "44px" }}>
                  {`Other: ${data.defe === "Other" && data.spec ? data.spec : ""}`}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <span className="spacer"></span>
        <ReportSignatureFooter
          fontSizeOverride={"20px"}
          sign1={{ signatureImage: "", bottomTitle: "Track Maintenance Foreman" }}
          sign2={{ signatureImage: signatureImage, bottomTitle: "Track Inspector" }}
          sign3={{ signatureImage: "", bottomTitle: "District Manager" }}
        />
      </div>
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ONR_InServiceRailFailureReportInstructions />
      </div>

      {/* Use following block to render Instructions for Mobile App Form */}
      {/* <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
          <ReportTitleSection title="DEFECT TYPES" hideLogo={true} fontSizeOverride="26px" />
          <span className="half-spacer"></span>
          <table className="table-bordered" style={{ width: "100%", fontSize: contentFontSize }}>
            <ReportTableSectionRenderer
              rowsData={onrInServiceRailFailureReportDefects.data}
              section={onrInServiceRailFailureReportDefects.schema}
            />
          </table>
        </div>

        <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle)}}>
          <ONR_InServiceRailFailureReportInstructions />
        </div> */}
    </Fragment>
  );
};

const ONR_InServiceRailFailureReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;
  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["onr_m_inServiceRailFailureAndMorbForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["onr_i_inServiceRailFailureAndMorbForm"]);

  const additionalReportParams = {
    location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
    subdivision: isMaintenance
      ? ReportGeneratorUtils.getMaintenanceSubdivision(inspec)
      : ReportGeneratorUtils.getInspectionSubdivision(inspec),
    date: ReportGeneratorUtils.getInspectionDate(inspec),
    user: ReportGeneratorUtils.getInspectionUser(inspec),
    isMaintenance: isMaintenance,
  };

  return formSummaries.map((summary, _i) => (
    <ReportView
      key={_i}
      {...props}
      reportData={{
        title: title,
        formSummary: summary,
        ...additionalReportParams,
      }}
    />
  ));
};

export default ONR_InServiceRailFailureReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/InServiceRailFailureReport/index.jsx